// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"81e4ea45","893":"9b466c03"}[chunkId] + ".chunk.js";
};